import React from 'react';
import { Stack, Typography, styled } from '@mui/material';
import {
  Notifications as NotificationsIcon,
  Error as ErrorMaterialIcon,
  InfoOutlined as InfoOutlinedIcon,
  CheckCircle as CheckCircleIcon,
  NotificationsNone,
} from '@mui/icons-material';

import { APP_NOTIFICATION_TYPE } from '../app/App.constants';

const NotificationWrapper = styled(Stack)`
  border: 1px solid red;
  background-color: ${({ bgColor }) => bgColor};
  border: ${({ borderColor }) => `1px solid ${borderColor}`};
  padding: 8px 16px;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  scroll-margin: 100px;
`;

const Message = styled(Typography)`
  line-height: 18px;
`;

const NOTIFICATION_BG_COLOR = {
  [APP_NOTIFICATION_TYPE.ERROR]: '#FBEBE9',
  [APP_NOTIFICATION_TYPE.SUCCESS]: '#E6F2EC',
  [APP_NOTIFICATION_TYPE.WARNING]: '#FFF4E5',
  [APP_NOTIFICATION_TYPE.INFO]: '#EAF1FB',
  [APP_NOTIFICATION_TYPE.INFO_V6]: '#F2F5FC',
  [APP_NOTIFICATION_TYPE.WARNING_V6]: '#FBF2E6',
};
const NOTIFICATION_BG_COLOR_DEFAULT = '#D9DBE0';

const NOTIFICATION_BORDER_COLOR = {
  [APP_NOTIFICATION_TYPE.ERROR]: '#8D1414',
  [APP_NOTIFICATION_TYPE.SUCCESS]: '#067E41',
  [APP_NOTIFICATION_TYPE.WARNING]: '#D97F00',
  [APP_NOTIFICATION_TYPE.INFO]: '#2F73D2',
  [APP_NOTIFICATION_TYPE.WARNING_V6]: '#D97F00',
};
const NOTIFICATION_BORDER_COLOR_DEFAULT = '#000000';

const NOTIFICATION_BORDER_RADIUS = {
  [APP_NOTIFICATION_TYPE.INFO_V6]: 4,
  [APP_NOTIFICATION_TYPE.WARNING_V6]: 4,
};
const NOTIFICATION_BORDER_RADIUS_DEFAULT = 2;

const NOTIFICATION_ICON = {
  [APP_NOTIFICATION_TYPE.ERROR]: (
    <ErrorMaterialIcon sx={{ color: '#8D1414' }} />
  ),
  [APP_NOTIFICATION_TYPE.SUCCESS]: (
    <CheckCircleIcon sx={{ color: '#036835' }} />
  ),
  [APP_NOTIFICATION_TYPE.WARNING]: (
    <NotificationsIcon sx={{ color: '#D97F00' }} />
  ),
  [APP_NOTIFICATION_TYPE.INFO]: <ErrorMaterialIcon sx={{ color: '#2F73D2' }} />,
  [APP_NOTIFICATION_TYPE.INFO_V6]: (
    <InfoOutlinedIcon sx={{ color: '#2C2B2F' }} />
  ),
  [APP_NOTIFICATION_TYPE.WARNING_V6]: (
    <NotificationsNone sx={{ color: '#D97F00' }} />
  ),
};

const NOTIFICATION_ICON_DEFAULT = <ErrorMaterialIcon />;

const NOTIFICATION_MSG_COLOR = {
  [APP_NOTIFICATION_TYPE.ERROR]: '#8D1414',
  [APP_NOTIFICATION_TYPE.SUCCESS]: '#036835',
  [APP_NOTIFICATION_TYPE.WARNING]: '#D97F00',
  [APP_NOTIFICATION_TYPE.INFO_V6]: '#2C2B2F',
};

const NOTIFICATION_MSG_COLOR_DEFAULT = '#000000';

const NOTIFICATION_FONT_SIZE = {
  [APP_NOTIFICATION_TYPE.INFO_V6]: '14px',
  [APP_NOTIFICATION_TYPE.WARNING_V6]: '14px',
};
const NOTIFICATION_FONT_SIZE_DEFAULT = '12px';

const NOTIFICATION_FONT_WEIGHT = {
  [APP_NOTIFICATION_TYPE.INFO_V6]: '400',
  [APP_NOTIFICATION_TYPE.WARNING_V6]: '400',
};
const NOTIFICATION_FONT_WEIGHT_DEFAULT = '500';

export default function Notification({ type, msg, msgKey }) {
  const bgColor = NOTIFICATION_BG_COLOR[type] || NOTIFICATION_BG_COLOR_DEFAULT;
  const borderColor =
    NOTIFICATION_BORDER_COLOR[type] || NOTIFICATION_BORDER_COLOR_DEFAULT;
  const borderRadius =
    NOTIFICATION_BORDER_RADIUS[type] || NOTIFICATION_BORDER_RADIUS_DEFAULT;

  const msgColor =
    NOTIFICATION_MSG_COLOR[type] || NOTIFICATION_MSG_COLOR_DEFAULT;
  const msgFontSize =
    NOTIFICATION_FONT_SIZE[type] || NOTIFICATION_FONT_SIZE_DEFAULT;
  const msgFontWeight =
    NOTIFICATION_FONT_WEIGHT[type] || NOTIFICATION_FONT_WEIGHT_DEFAULT;

  const renderMsg = () => {
    if (msgKey) return `${msgKey} (This key will be translated)`;
    if (msg) return msg;

    return 'Please enter a message';
  };

  return (
    <NotificationWrapper
      bgColor={bgColor}
      borderColor={borderColor}
      borderRadius={borderRadius}>
      {NOTIFICATION_ICON[type] || NOTIFICATION_ICON_DEFAULT}
      <Message
        color={msgColor}
        fontSize={msgFontSize}
        fontWeight={msgFontWeight}>
        {renderMsg()}
      </Message>
    </NotificationWrapper>
  );
}
